(function () {
  if (window.__tbwPerfHydratorInitialized) return;
  window.__tbwPerfHydratorInitialized = true;

  var io = null;

  function hydrate(img) {
    if (!img || img.dataset.perfLoaded === '1') return;
    var src = img.getAttribute('data-perf-src');
    var srcset = img.getAttribute('data-perf-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.dataset.perfLoaded = '1';
  }

  function watch(img) {
    if (!img || img.dataset.perfLoaded === '1') return;
    if (io) {
      io.observe(img);
      return;
    }
    hydrate(img);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope || !scope.querySelectorAll) return;
    var imgs = scope.querySelectorAll('img[data-perf-src], img[data-perf-srcset]');
    for (var i = 0; i < imgs.length; i++) watch(imgs[i]);
  }

  function boot() {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            hydrate(entries[i].target);
            observer.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '300px 0px' });
    }

    scan(document);

    if ('MutationObserver' in window && document.documentElement) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var addedNodes = mutations[i].addedNodes;
          for (var j = 0; j < addedNodes.length; j++) {
            var node = addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            if (node.matches && (node.matches('img[data-perf-src]') || node.matches('img[data-perf-srcset]'))) {
              watch(node);
            }
            scan(node);
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    // Hard fallback: ensure placeholders never persist.
    window.setTimeout(function () {
      var pending = document.querySelectorAll('img[data-perf-src], img[data-perf-srcset]');
      for (var i = 0; i < pending.length; i++) hydrate(pending[i]);
    }, 1800);

    window.addEventListener('load', function () {
      var pending = document.querySelectorAll('img[data-perf-src], img[data-perf-srcset]');
      for (var i = 0; i < pending.length; i++) hydrate(pending[i]);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
